import { render, staticRenderFns } from "./AppNavigationDrawer.vue?vue&type=template&id=870839de&scoped=true"
import script from "./AppNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./AppNavigationDrawer.vue?vue&type=script&lang=js"
import style0 from "./AppNavigationDrawer.vue?vue&type=style&index=0&id=870839de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870839de",
  null
  
)

export default component.exports